module.exports = __webpack_public_path__ + "img/server1.c2dc7f9.png";